<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- 产品编码 productCode-->
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.code')" prop="productCode">
            <BjInput v-model="queryParams.productCode" :placeholder="$t('QuotationCustomerLang.code')" />
          </el-form-item>
        </el-col>
        <!-- 报价等级 quotationLevel： 0.普通报价。1.vip客户报价 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.Level')" prop="quotationLevel">
            <BjSelectLov v-model="queryParams.quotationLevel" :placeholder="$t('QuotationCustomerLang.Level')" :option-list="quotationLevelList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 物流产品 productId -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.LogisticsProduct')" prop="productId">
            <BjSelectLov v-model="queryParams.productId" :placeholder="$t('QuotationCustomerLang.LogisticsProduct')" :option-list="logisticsProductList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 状态 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.Status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :placeholder="$t('QuotationCustomerLang.Status')" :option-list="statusList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 生效时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.EffectiveTime')" prop="effectiveTime">
            <BjDateRangePicker v-model="queryParamsTime_effectiveTime" :tip-show="true" :placeholder="$t('QuotationCustomerLang.EffectiveTime')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 备注 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.remarkText')" prop="remark">
            <BjInput v-model="queryParams.remark" :placeholder="$t('table.remarkText')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button type="primary" plain @click="onAdd()">{{ $t('addText') }}</el-button>
          <el-button :disabled="tableOperationProp.notSelected || hasSelectedStatus(1)" type="primary" plain @click="onEnable()">{{ $t('enableText') }}</el-button>
          <el-button :disabled="tableOperationProp.notSelected || hasSelectedStatus(0)" type="primary" plain @click="onDisable()">{{ $t('QuotationCenter.status3') }}</el-button>
          <BjFrontendExport
            :disabled="tableOperationProp.notSelected"
            type="primary"
            plain
            :label-list="labelList"
            :rows="selectedRows"
            file-name="Customer Standard Quotation.csv"
          />
          <el-button v-permission:BusinessDeleteQuotationCustomerButton :disabled="tableOperationProp.notSelected" type="primary" plain @click="batchDelete()">{{ $t('bulkDelText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'productId'">
                <span>{{ $t(logisticsProductList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="col.prop === 'quoteId'">
                <span>{{ scope.row.quoteId }}</span>
                <BjCopyIcon :copy="scope.row.quoteId" />
              </template>
              <template v-else-if="col.prop == 'discount'">
                <span>{{ scope.row[col.prop]? $number2money(scope.row[col.prop]) + ' %' : '' }}</span>
              </template>
              <template v-else-if="col.prop == 'quotationLevel'">
                <span>{{ $t(quotationLevelList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="col.prop == 'quotationMethod'">
                <span>{{ $t(quotationMethodList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="col.prop == 'status'">
                <el-tag v-if="[0,1,2].includes(scope.row[col.prop])"
                  :type="scope.row[col.prop] == 1 ? 'success' : (scope.row[col.prop] == 2 ? 'warning' : 'info')">
                  {{ $t(statusList.bjGet(scope.row[col.prop])) }}
                </el-tag>
              </template>
              <template v-else>{{ scope.row[col.prop] | quotationTimeFilter(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onCopy(props.row)">{{ $t('copyText') }}</el-button>
                <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="goView">{{ $t('detailsText') }}</el-dropdown-item>
                    <el-dropdown-item command="goVIP" :disabled="props.row.quotationLevel !== 1">{{ $t('QuotationCustomerLang.bindCustomer') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="550px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-position="top" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCustomerLang.LogisticsProduct')" prop="productId">
              <BjSelectLov v-model="form.productId" :placeholder="$t('QuotationCustomerLang.LogisticsProduct')" :option-list="logisticsProductList" @change="getProductCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCustomerLang.LogisticsProductCode')" prop="productCode">
              <BjInput v-model="form.productCode" disabled :placeholder="$t('QuotationCustomerLang.LogisticsProductCode')" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCustomerLang.Currency')" prop="currency">
              <BjSelectLov v-model="form.currency" :placeholder="$t('QuotationCustomerLang.Currency')" :option-list="currencyList" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCustomerLang.Level')" prop="quotationLevel">
              <BjSelectLov v-model="form.quotationLevel" :placeholder="$t('QuotationCustomerLang.Level')" :option-list="quotationLevelList" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('QuotationCustomerLang.QuotationMethod')" prop="quotationMethod">
          <BjSelectLov v-model="form.quotationMethod" :placeholder="$t('QuotationCustomerLang.QuotationMethod')" :option-list="quotationMethodList" />
        </el-form-item>
        <el-row v-if="form.quotationMethod === 1" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCustomerLang.ChannelQuotationID')" prop="linkId">
              <BjInputNumber v-model="form.linkId" :precision="0" :maxlength="18" string-mode not-auto-zero :placeholder="$t('QuotationCustomerLang.ChannelQuotationID')" clearable @input="normalizeLinkId" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCustomerLang.Discount')" prop="discount">
              <BjInputNumber v-model="form.discount" :min="0" :precision="2" :maxlength="10" not-auto-zero :placeholder="$t('QuotationCustomerLang.Discount')" clearable @input="normalizeDiscount">
                <template slot="append">%</template>
              </BjInputNumber>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('QuotationCustomerLang.EffectiveTime')" prop="effectiveTime">
          <el-date-picker
            v-model="queryParamsTime_form_effectiveTime" prop="effectiveTime"
            class="full-width" format="dd/MM/yyyy HH:mm:ss"
            type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            :start-placeholder="$t('form.startDateText')"
            :end-placeholder="$t('form.endDateText')"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-form-item :label="$t('table.remarkText')" prop="remark">
          <BjInput v-model="form.remark" :placeholder="$t('inputText')" type="textarea" :rows="5" show-word-limit autosize maxlength="500" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { logisticApi } from '@/api';
import { getLanguage } from '@/lang/index';
import pageMiXin from '@/utils/page-mixin.js';

const LINK_ID_PATTERN = /^\d{18}$/;
const DISCOUNT_PATTERN = /^\d+(?:\.\d{0,2})?$/;

function getLinkIdLengthMismatchMessage() {
  return getLanguage() === 'zh' ? '位数不匹配' : 'Length Mismatch';
}

const getDefaultForm = () => {
  return {
    quoteType: 1, // 报价类型 :  0供应商报价 1客户报价
    productId: null,
    productCode: null,
    currency: null,
    quotationLevel: null,
    quotationMethod: null,
    linkId: null,
    discount: null,
    startTime: null,
    endTime: null,
    remark: null,
  };
};

export default {
  name: 'BusinessQuotationCustomer',
  components: {},
  mixins: [pageMiXin],
  data() {
    const validateTime = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.form.startTime || !this.form.endTime) {
          callback(new Error(this.$t('chooseText')));
        } else {
          callback();
        }
      }, 300);
    };
    const validateLinkId = (rule, value, callback) => {
      if (this.form.quotationMethod !== 1) {
        callback();
        return;
      }
      if (value === '' || value === null || value === undefined || String(value).trim() === '') {
        callback(new Error(this.$t('inputText')));
        return;
      }
      const linkId = String(value).trim();
      if (!LINK_ID_PATTERN.test(linkId)) {
        callback(new Error(getLinkIdLengthMismatchMessage()));
        return;
      }
      callback();
    };
    return {
      colSpan: 4,
      selection: true,
      queryApi: logisticApi.getQuotesPageList,
      queryChangeTimer: null,
      isResettingQuery: false,
      queryParamsTime_effectiveTime: [],
      queryParamsTime_form_effectiveTime: [],
      queryParams: {
        quoteType: 1, // 报价类型 :  0供应商报价 1客户报价
        productCode: null,
        quotationLevel: null,
        productId: null,
        status: null,
        remark: null,
        startTime: '',
        endTime: '',
      },
      // 报价等级 :  0普通报价 1VIP客户报价
      quotationLevelList: [
        { label: this.$t('QuotationCustomerLang.Quotation'), value: 0 },
        { label: this.$t('QuotationCustomerLang.VIP'), value: 1 },
      ],
      // 状态 :  0停用 1启用
      statusList: [
        { label: this.$t('QuotationCustomerLang.Disabled'), value: 0 },
        { label: this.$t('QuotationCustomerLang.Enabled'), value: 1 },
      ],
      // 物流产品列表
      logisticsProductList: [],
      labelList: [
        { label: this.$t('QuotationCustomerLang.code'), prop: 'productCode', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('QuotationCustomerLang.Supplier'), prop: 'quoteId', isCheck: true, disabled: false, width: 152 },
        { label: this.$t('QuotationCustomerLang.Discount'), prop: 'discount', isCheck: true, disabled: false, width: 100, export: { formatter: value => value || value === 0 ? `${this.$number2money(value)} %` : '' } },
        { label: this.$t('QuotationCustomerLang.Level'), prop: 'quotationLevel', isCheck: true, disabled: false, width: 150, export: { options: () => this.quotationLevelList, translate: true } },
        { label: this.$t('QuotationCustomerLang.QuotationMethod'), prop: 'quotationMethod', isCheck: true, disabled: false, width: 114, export: { options: () => this.quotationMethodList, translate: true } },
        { label: this.$t('QuotationCustomerLang.LogisticsProduct'), prop: 'productId', isCheck: true, disabled: false, width: 150, export: { options: () => this.logisticsProductList, translate: true } },
        { label: this.$t('QuotationCustomerLang.ChannelQuotationID'), prop: 'linkId', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('QuotationCustomerLang.Currency'), prop: 'currency', isCheck: true, disabled: false, width: 90 },
        { label: this.$t('QuotationCustomerLang.Status'), prop: 'status', isCheck: true, disabled: false, width: 90, export: { options: () => this.statusList, translate: true } },
        { label: this.$t('QuotationCustomerLang.StartDate'), prop: 'startTime', isCheck: true, disabled: false, width: 150, export: { dateFormat: 'DD/MM/YYYY HH:mm:ss' } },
        { label: this.$t('QuotationCustomerLang.EndDate'), prop: 'endTime', isCheck: true, disabled: false, width: 150, export: { dateFormat: 'DD/MM/YYYY HH:mm:ss' } },
        { label: this.$t('QuotationCustomerLang.CreatedBy'), prop: 'createdName', isCheck: true, disabled: false },
        { label: this.$t('table.remarkText'), prop: 'remark', isCheck: true, disabled: false, width: 120 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 160 },
      ],

      // 弹窗相关数据
      dialogTitle: null,
      dialogFormVisible: false,
      form: getDefaultForm(),
      copyId: null,
      rules: {
        productId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        productCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        currency: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        quotationLevel: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        quotationMethod: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        linkId: [{ required: true, validator: validateLinkId, trigger: 'blur' }],
        discount: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { pattern: DISCOUNT_PATTERN, message: this.$t('formatErrorText'), trigger: 'blur' },
        ],
        effectiveTime: [{ required: true, validator: validateTime, trigger: 'change' }],
      },
      currencyList: [
        // 新增的时候默认 AUD
        { label: 'AUD', value: 'AUD' },
        { label: 'CNY', value: 'CNY' },
        { label: 'USD', value: 'USD' },
      ],
      quotationMethodList: [
        { label: this.$t('QuotationCustomerLang.Standard'), value: 0 },
        { label: this.$t('QuotationCustomerLang.Channel'), value: 1 },
      ],
    };
  },
  watch: {
    queryParamsTime_effectiveTime(v) {
      this.queryParams.startTime = (v || [])[0];
      this.queryParams.endTime = (v || [])[1];
    },
    queryParamsTime_form_effectiveTime(v) {
      this.form.startTime = (v || [])[0];
      this.form.endTime = (v || [])[1];
    },
    'form.quotationMethod'(v) {
      if (v === 0) {
        this.form.linkId = null;
        this.form.discount = null;
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate(['linkId', 'discount']);
        });
      }
    },
  },
  mounted() {
    // 获取物流产品列表（不需要传参数）
    logisticApi.getLogisticProductList({}).then(res => {
      this.logisticsProductList = (res.content || []).map(item => ({
        label: item.productName,
        value: item.id,
        code: item.productCode,
      }));
    });
  },
  methods: {
    // 判断选中数据是否可以启用、停用
    hasSelectedStatus(status) {
      return this.selectedRows.some(item => String(item.status) === String(status));
    },
    command(text, row) {
      switch (text) {
        case 'goView':
            this.$router.push({ name: 'BusinessQuotationCustomerDetails', query: { id: row.id } });
            break;
        case 'goVIP':
            this.$router.push({ name: 'BusinessQuotationVIPCustomer', query: { quoteId: row.quoteId } });
            break;
      }
    },
    getProductCode(n, m) {
      this.form.productCode = m.code;
    },
    normalizeLinkId(value) {
      const normalized = String(value || '').replace(/\D/g, '').slice(0, 18);
      if (this.form.linkId !== normalized) {
        this.form.linkId = normalized;
      }
    },
    normalizeDecimalValue(value, precision) {
      if (value === '' || value === null || value === undefined) {
        return value;
      }
      const parts = String(value)
        .replace(/[^\d.]/g, '')
        .replace(/^\./, '')
        .split('.');
      if (parts.length === 1) {
        return parts[0];
      }
      return `${parts[0]}.${parts.slice(1).join('').slice(0, precision)}`;
    },
    normalizeDiscount(value) {
      const normalized = this.normalizeDecimalValue(value, 2);
      if (this.form.discount !== normalized) {
        this.form.discount = normalized;
      }
    },
    getSubmitForm() {
      const form = {
        ...this.form,
      };
      if (form.linkId !== null && form.linkId !== undefined) {
        form.linkId = String(form.linkId).trim();
      }
      if (form.discount !== null && form.discount !== undefined && form.discount !== '') {
        form.discount = Number(this.normalizeDecimalValue(form.discount, 2));
      }
      return form;
    },
    onAdd() {
      this.dialogTitle = this.$t('addText');
      this.copyId = null;
      this.form.currency = 'AUD'; // 币种新增时默认 AUD
      this.dialogFormVisible = true;
    },
    onEdit(row) {
      this.dialogTitle = this.$t('editText');
      this.copyId = null;
      this.form = JSON.parse(JSON.stringify(row));
      this.queryParamsTime_form_effectiveTime = row.startTime && row.endTime ? [row.startTime, row.endTime] : [];
      this.dialogFormVisible = true;
    },
    onCopy(row) {
      this.dialogTitle = this.$t('copyText');
      this.copyId = row.id;
      this.form = JSON.parse(JSON.stringify(row));
      this.queryParamsTime_form_effectiveTime = row.startTime && row.endTime ? [row.startTime, row.endTime] : [];
      this.dialogFormVisible = true;
    },

    // form表单验证
    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => resolve(valid));
      });
    },
    // 验证 渠道报价ID 是否存在
    async validateLinkQuote() {
      if (this.form.quotationMethod !== 1) {
        return true;
      }
      const linkId = String(this.form.linkId || '').trim();
      if (!linkId) {
        return true;
      }

      const res = await logisticApi.getQuotesPageList({
        size: 20,
        page: 0,
        total: 24,
        pageSize: 20,
        currentPage: 0,
        quoteId: linkId,
      });
      const hasData = Array.isArray(res.content) && res.content.length > 0;
      if (!hasData) {
        this.msgError(this.$t('QuotationCustomerLang.Exist'));
      }
      return hasData;
    },
    // 保存弹窗数据 并 关闭编辑弹窗
    async saveAmount() {
      const valid = await this.validateForm();
      if (!valid) return;

      const quoteValid = await this.validateLinkQuote();
      if (!quoteValid) return;

      const submitForm = this.getSubmitForm();
      if (this.dialogTitle == this.$t('addText')) {
        logisticApi.addQuotesPageList(submitForm).then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.handleClose();
            this.reFresh();
          }
        });
      } else if (this.dialogTitle == this.$t('copyText')) {
        logisticApi.copyQuotesPageList({ ...submitForm, id: this.copyId }).then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.handleClose();
            this.reFresh();
          }
        });
      } else if (this.dialogTitle == this.$t('editText')) {
        logisticApi.editQuotesPageList(submitForm).then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.handleClose();
            this.reFresh();
          }
        });
      }
    },

    /** 关闭弹窗 清空数据 */
    handleClose() {
      this.form = getDefaultForm();
      this.copyId = null;
      this.queryParamsTime_form_effectiveTime = [];
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
    },
    onEnable() {
      logisticApi.changeQuotesPageStatus({ids: this.selectedRows.map(e => e.id), status: 1}).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    onDisable() {
      logisticApi.changeQuotesPageStatus({ids: this.selectedRows.map(e => e.id), status: 0}).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    batchDelete() {
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          logisticApi.deleteQuotesPageList({ids: ids}).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
        .catch(() => { });
    },
    // 清空选中数据 刷新表格数据 关闭所有标签页
    reFresh() {
      this.handleSelectionChange({});
      this.$refs.BjPage && this.$refs.BjPage.handleAllTagsClose();
      this.$refs.BjPage && this.$refs.BjPage.fetchData();
    },
    // 避免重复调用列表接口
    handleQuery() {
      if (this.isResettingQuery) return;
      clearTimeout(this.queryChangeTimer);
      this.queryChangeTimer = setTimeout(() => {
        this.reFresh();
      }, 300);
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.isResettingQuery = true;
      clearTimeout(this.queryChangeTimer);
      this.queryParamsTime_effectiveTime = [];

      return new Promise(resolve => {
        this.$nextTick(() => {
          this.isResettingQuery = false;
          resolve();
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
